var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-card__title mb-12"},[_c('div',{staticClass:"my-10 text-center",domProps:{"innerHTML":_vm._s(_vm.$t('message.login.restoreInstructions'))}}),_c('a',{attrs:{"href":"javascript: void(0)"},on:{"click":function($event){return _vm.$emit('close-restore')}}},[_vm._v("\n    "+_vm._s(_vm.$t('message.login.authForm'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }